export default __webpack_public_path__ + "static/media/175.a84d0006.jpg";